
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { BASE_URL } from '../BaseURL';

const DonationTable = () => {


    const [search, setSearch] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [donations, setDonations] = useState([]);
    const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1 });

    // Fetch donations from API
    const fetchDonations = async (page = 1) => {
        try {
            setLoading(true);
            const params = {
                search,
                fromDate,
                toDate,
                page,
                limit: 20,
            };

            const { data } = await axios.get(`${BASE_URL}/donation/getAllDonation`, { params });

            if (data.success) {
                setDonations(data.data);
                setPagination(data.pagination);
            } else {
                setDonations([]);
                toast.error('No donation records found.');
            }
        } catch (err) {
            toast.error('Error fetching donations');
        } finally {
            setLoading(false);
        }
    };

    // Auto-fetch on filter change (with debounce)
    useEffect(() => {
        const delay = setTimeout(() => {
            fetchDonations(1);
        }, 400);

        return () => clearTimeout(delay);
    }, [search, fromDate, toDate]);

    // Initial load
    useEffect(() => {
        fetchDonations();
    }, []);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            fetchDonations(newPage);
        }
    };


    const handleExport = () => {
        const params = new URLSearchParams({
            search,
            fromDate,
            toDate,
        });

        const link = document.createElement('a');
        link.href = `${BASE_URL}/donation/exportDonationsExcel?${params.toString()}`;
        link.setAttribute('download', 'donations.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <div className="table-container">
            <Toaster position="top-center" />
            <h2 className="text-center mb-4">Donations</h2>

            {/* 🔍 Filters */}

            <div className="row mb-3">
                <div className="col-md-3 mb-2">
                    <input
                        type="text"
                        placeholder="Search Name or Payment ID"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="form-control"
                    />
                </div>

                <div className="col-md-3 mb-2">
                    <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        className="form-control"
                    />
                </div>

                <div className="col-md-3 mb-2">
                    <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        className="form-control"
                    />
                </div>

                <div className="col-md-3 mb-2">
                    <button className="btn btn-success w-100" onClick={handleExport}>
                        📁 Export to Excel
                    </button>
                </div>
            </div>



            {/* 📊 Table */}
            
            {loading ? (
                <div className="text-center py-4">
                    <Spinner animation="border" variant="success" />
                </div>
            ) : (
                <div className="table-responsive">
  <table className="table table-bordered table-striped">
                    <thead className="bg-success text-white">
                        <tr>
                            <th>Sr</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Mob No.</th>
                            <th>Amount</th>
                            <th>Payment Status</th>
                            <th>Donation Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {donations.length > 0 ? (
                            donations.map((item, index) => (
                                <tr key={item._id}>
                                    <td>{(pagination.currentPage - 1) * 10 + index + 1}</td>
                                    <td>{item.fullName}</td>
                                    <td>{item.email}</td>
                                    <td>{item.phone}</td>
                                    <td>${item.amount}</td>
                                    <td className="text-success">{item.paymentStatus}</td>
                                    <td>{new Date(item.createdAt).toLocaleString()}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center">
                                    No records found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                </div>
            )}

            {/* 📄 Pagination */}
          

            <div className="pagination-controls d-flex justify-content-center align-items-center gap-3 mt-3">
                <button
                    className="btn btn-light"
                    disabled={pagination.currentPage === 1}
                    onClick={() => handlePageChange(pagination.currentPage - 1)}
                >
                    Prev
                </button>
                <span>
                    Page {pagination.currentPage} of {pagination.totalPages}
                </span>
                <button
                    className="btn btn-light"
                    disabled={pagination.currentPage === pagination.totalPages}
                    onClick={() => handlePageChange(pagination.currentPage + 1)}
                >
                    Next
                </button>
            </div>


        </div>
    );
};

export default DonationTable;
